import { render, staticRenderFns } from "./UICreateLeagueModal.vue?vue&type=template&id=b604138e&scoped=true"
import script from "./UICreateLeagueModal.vue?vue&type=script&lang=js"
export * from "./UICreateLeagueModal.vue?vue&type=script&lang=js"
import style0 from "./UICreateLeagueModal.vue?vue&type=style&index=0&id=b604138e&prod&lang=scss"
import style1 from "./UICreateLeagueModal.vue?vue&type=style&index=1&id=b604138e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b604138e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default,PremiumOnlyTag: require('/skade-pwa/components/ui/atom/PremiumOnlyTag.vue').default,Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
